export const UPDATE_SELECTED_TYPE = content => ({
    type: "UPDATE_SELECTED_TYPE",
    payload: content
});

export const UPDATE_SELECTED_WARRANTY_STATUS = content => ({
    type: "UPDATE_SELECTED_WARRANTY_STATUS",
    payload: content
});

export const UPDATE_SELECTED_EXPIRATION_START_DATE = content => ({
    type: "UPDATE_SELECTED_EXPIRATION_START_DATE",
    payload: content
});

export const UPDATE_SELECTED_EXPIRATION_END_DATE = content => ({
    type: "UPDATE_SELECTED_EXPIRATION_END_DATE",
    payload: content
});

export const UPDATE_SELECTED_TENANT_ID = content => ({
    type: "UPDATE_SELECTED_TENANT_ID",
    payload: content
});

export const UPDATE_SELECTED_ASSIGNED_TO_USER = content => ({
    type: "UPDATE_SELECTED_ASSIGNED_TO_USER",
    payload: content
});

export const UPDATE_SELECTED_SERIAL_NUMBER = content => ({
    type: "UPDATE_SELECTED_SERIAL_NUMBER",
    payload: content
});

export const UPDATE_SELECTED_ASSET_TAG = content => ({
    type: "UPDATE_SELECTED_ASSET_TAG",
    payload: content
});

export const UPDATE_SEARCH_TEXT_HARDWARE_ASSET = content => ({
    type: "UPDATE_SEARCH_TEXT_HARDWARE_ASSET",
    payload: content
});

export const UPDATE_HARDWARE_ASSET_SORT_BY = content => ({
    type: "UPDATE_HARDWARE_ASSET_SORT_BY",
    payload: content
});

export const UPDATE_HARDWARE_ASSET_SORT_ORDER = content => ({
    type: "UPDATE_HARDWARE_ASSET_SORT_ORDER",
    payload: content
});

export const RESET_HARDWARE_ASSET_FILTERS = content => ({
    type: "RESET_HARDWARE_ASSET_FILTERS",
    payload: content
});

export const UPDATE_SELECTED_COMPANY_IN_ADD_ASSET_FORM_HARDWARE = content => ({
    type: "UPDATE_SELECTED_COMPANY_IN_ADD_ASSET_FORM_HARDWARE",
    payload: content
});

export const UPDATE_SELECTED_HARDWARE_ASSET_DATA_VIEW = content => ({
    type: "UPDATE_SELECTED_HARDWARE_ASSET_DATA_VIEW",
    payload: content
});

export const UPDATE_SELECTED_HARDWARE_ASSET_CUSTOMER = content => ({
    type: "UPDATE_SELECTED_HARDWARE_ASSET_CUSTOMER",
    payload: content
});

export const UPDATE_ORDER_PLACEMENT_TIMESPAN = content => ({
    type: "UPDATE_ORDER_PLACEMENT_TIMESPAN",
    payload: content
});

export const UPDATE_SELECTED_ORDER_STATUS = content => ({
    type: "UPDATE_SELECTED_ORDER_STATUS",
    payload: content
});

export const UPDATE_HARDWARE_ORDERS_SORT_BY = content => ({
    type: "UPDATE_HARDWARE_ORDERS_SORT_BY",
    payload: content
});

export const UPDATE_HARDWARE_ORDERS_SORT_ORDER = content => ({
    type: "UPDATE_HARDWARE_ORDERS_SORT_ORDER",
    payload: content
});